import React from "react";

import { Input, Label, Spinner } from "reactstrap";

import { formatWritingAuditOption } from "./writingAssistantUtils";
import { normalizeAuditId } from "../../../utils/auditIdUtils";



export default function AuditSelectSection({ audits, loading, auditId, onSelect }) {

	return (

		<div className="writing-assistance__field">

			<Label for="writing-assistance-audit" className="writing-assistance__label">

				Completed audit

			</Label>

			<div className="position-relative">

				<Input

					id="writing-assistance-audit"

					type="select"

					className="writing-assistance__select"

					value={auditId ?? ""}

					disabled={loading}

					onChange={(e) => {

						const value = e.target.value;

						onSelect(value === "" ? null : normalizeAuditId(value));

					}}

				>

					<option value="">{loading ? "Loading audits…" : "Select an audit…"}</option>

					{(audits || []).map((audit) => (

						<option key={audit.id} value={audit.id}>

							{formatWritingAuditOption(audit)}

						</option>

					))}

				</Input>

				{loading && (

					<div className="position-absolute top-50 end-0 translate-middle-y me-4">

						<Spinner size="sm" />

					</div>

				)}

			</div>

		</div>

	);

}

